<template>
  <div class="uni-course-notes studyNotes">
    <!-- video-header -->
    <div class="video-header">
      <div class="left">
        <span class="title" @click="isShowFace(5)">{{
          courseDatas.title
        }}</span>
      </div>
      <div class="right">
        <span class="opera fr" @click="$router.go(-1)">
          <i class="iconfont iconfanhuijiantou"></i>
          返回
        </span>
      </div>
    </div>

    <!-- video-box -->
    <div class="video-wrap">
      <!-- 视频播放器-->
      <div class="video-box" id="uniVideoPlayer">
        <!-- <TYVideo
          ref="tenCenVideo"
          :videoData="videoData"
          @lessonChangeNext="lessonNext"
          @isShowFace="isShowFace"
        /> -->
        <TencenVideo
          ref="tenCenVideo"
          :videoData="videoData"
          :lessonsUuid="lessonsUuid"
          :sectionDatas="sectionDatas"
          @lessonChangeNext="lessonNext"
          @isShowFace="isShowFace"
        />
      </div>

      <!-- 记笔记 -->
      <div class="notes-box" :class="isNoteVisible ? 'hide' : ''">
        <Notes
          :lessonsUuid="lessonsUuid"
          :courseDatas="sectionDatas"
          :teacherDatas="teacherData"
          @change="lessonChange"
        />
      </div>

    
    </div>

    <FaceVideo v-if="isFaceVideo" @isRouter="isRouter" @isFailure="isFailure" />
  </div>
</template>

<script>
import Notes from "./notes";
import TencenVideo from "@/components/TencenVideo";
// import TYVideo from "@/components/TYVideo";
import FaceVideo from "@/components/faceVideo";
import { getCourseDetails, getSections, getSectionDetail } from "@/api/basic";
export default {
  name: "Course",
  components: {
    Notes, //记笔记
    TencenVideo,
    // TYVideo,  //天翼播放器
    FaceVideo,
  },
  data() {
    return {
      courseId: this.$route.query.course_id,
      lessonsUuid: Number(this.$route.query.lession_id),
      videoData: {},
      isNoteVisible: false,
      isMenuVisible: false,
      isFaceVideo: false, // 人脸识别
      faceFrequency: null,
      isFace: false,
      courseDatas: {},
      sectionDatas: [],
      nextSectionIndex: 0,
      nextSectionIndex2: 0,
      teacherData:{},
      fileName: {},
    };
  },
  mounted() {
    this.getDatas();
    this.getSections();
    this.lessonChange(this.lessonsUuid);
  },
  methods: {
    // 课程详情
    async getDatas() {
      const params = {
        course_id: this.courseId,
      };
      const { result } = await getCourseDetails(params);
      if (result) {
        this.courseDatas = result.course;
        this.teacherData = result.teacher;
      }
    },
    // 章节列表
    async getSections() {
      const params = {
        course_id: this.courseId,
      };
      const { result } = await getSections(params);
      if (result) {
        this.sectionDatas = result;
      }
    },
    // 章节切换
    lessonChange(val) {
      getSectionDetail({
        course_id: this.courseId,
        section_id: val,
      }).then((res) => {
        if (res.code == 200) {
          if (res.result) {
            const { section_info } = res.result;
            // if (section_info.file_id) {
            if (section_info.video !== '') {
              this.lessonsUuid = val;
              this.videoData = res.result;
            } else {
              this.$message.warning("该课节暂无视频可观看");
            }
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    lessonNext() {
      let lessions = [];
      this.sectionDatas.forEach((item) => {
        if (item.node) {
          item.node.forEach((node) => {
            lessions.push(node.id);
          });
        }
      });

      let inx = lessions.indexOf(this.lessonsUuid);
      if (inx != -1 && inx < lessions.length - 1) {
        let lessonsUuid = lessions[inx + 1];
        this.lessonChange(lessonsUuid);
      } else {
        this.$message.success("本课程已经学习完毕,暂无下-节内容");
      }
    },
    // 人脸识别
    isShowFace() {
      this.isFaceVideo = true;
    },
    isRouter() {
      this.isFaceVideo = false;
      this.$refs.tenCenVideo.videoPlay();
    },
    isFailure() {
      console.log("失败");
      this.isFaceVideo = false;
      this.$refs.tenCenVideo.resetVideo();
    },
  },
};
</script>

<style lang="scss" scoped>
$rightW: 450px;
$videoWrapH: calc(100vh - 70px);
.uni-course-notes {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .video-header {
    width: 100%;
    height: 70px;
    background: $blackLight;
    color: #fff;
    display: flex;
    align-items: center;

    .left {
      flex: 1;
      font-size: 16px;
      padding: 0 20px;
    }

    .right {
      width: $rightW;
      padding: 0 20px;
    }

    .iconfont {
      font-size: 16px;
      vertical-align: middle;
      margin-right: 4px;
    }
    .title {
      font-size: 18px;
      margin-left: 30px;
    }
    .opera {
      cursor: pointer;
    }
  }

  .video-wrap {
    height: $videoWrapH;
    background: #000;
    display: flex;
    position: relative;
    overflow: hidden;

    .video-box {
      flex: 1;
    }
  }

  .notes-box {
    width: $rightW;
    background: #fff;
    transition: all 0.3s ease-in-out;

    &.hide {
      width: 0;
    }
  }
}
</style>
